var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage beginning-letter"
  }, [_vm.activityData && _vm.currentRound ? _c('div', {
    staticClass: "round-image-container"
  }, [_c('figure', {
    staticClass: "round-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentRound.image,
      "alt": _vm.currentRound.imageName
    }
  }), _vm.showAnswer ? _c('figcaption', {
    domProps: {
      "textContent": _vm._s(_vm.imageName)
    }
  }) : _vm._e()]), !_vm.hideKey && !_vm.showAnswer ? _c('span', {
    class: ['current-key-container keyStyle ', ("to-" + (_vm.getKeyType())), _vm.getKeyColor()],
    domProps: {
      "textContent": _vm._s(_vm.currentStep.answer)
    }
  }) : _vm._e()]) : _vm._e(), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }